import { RootState } from 'redux-state/store';

const defaultArray: string[] = [];

export const getOpenedModals = (state: RootState) => state.modals || defaultArray;
